import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid, makeStyles, Button } from '@material-ui/core';
import { formattingDigitCurrency } from 'utils';
import { DetailProductLine } from 'Components/Ticket/Product';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import {
  displayListContentAtom,
} from 'Atoms/Ticket';

const useStyles = makeStyles((theme) => ({
  listContainer: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
  listInnerContainer: {
    borderRadius: '1rem',
    overflow: 'auto'
  },
  listItem: {
    background: 'white',
    minHeight: '55px',
    //margin: '5px 0',
    padding: '1rem',
  },
  showMore: {
    background: 'white',
    minHeight: '55px',
    //margin: '5px 0',
    padding: '.5rem',
    textAlign: 'center'
  },
  showMoreButton: {
    padding: '0 1rem',
    textTransform: 'inherit',
  }
}));
const ListDetails = ({ listProducts, currency }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [displayListContent, setDisplayListContent] = useAtom(displayListContentAtom);
  const sections = listProducts;
  const action = {
    name: 'readOnly',
  };
  
  const listLength = displayListContent?Math.max:2;

  let nb = 0;
  let stop = false;
  let list = [];
  for(let section of sections){
    let linesList = [];
    for(let line of section.lines){
      linesList.push(
        <Grid
          item
          xs={12}
          key={`${section.name}-line-${line.id}`}
          className={classes.listItem}
        >
          <DetailProductLine
            action={action}
            label={line.label}
            price={line.price}
            quantity={line.nb}
            sublines={line.sublines}
            offered={line.offered}
            priceBeforeDiscount={line.priceBeforeDiscount}
          />
        </Grid>
      );
      nb++;
      stop = nb > listLength;
      if(stop){
        break;
      }
    }
    list.push(
      <Grid item xs={12} key={section.id} className={classes.listContainer}>
        <Grid container direction="row" className={classes.listInnerContainer}>
          {linesList}
          {stop?
            <Grid
              item
              xs={12}
              key={`show-me`}
              className={classes.showMore}
              onClick={()=>{setDisplayListContent(true);}}>
                <Button
                  variant="outlined"
                  size="small"
                  className={classes.showMoreButton}
                >
                 {t('seeTheOrderContent')}
                </Button>
            </Grid>:null}
        </Grid>
      </Grid>
    );
    if(stop){
      break;
    }
  }
  return (
    <Grid container>
      {list}
    </Grid>
  );
};

ListDetails.propTypes = {
  listProducts: PropTypes.array,
};

export default ListDetails;
